<template>
    <div v-if="visible">
        <el-dialog title="综合素养报告模板下载" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose"
            width="1000px">
            <el-form ref="form" :model="form" :inline="true" :rules="rules" label-width="130px">

                <el-row>
                    <el-col :span="8">
                        <el-form-item prop="startDate" label="开始日期">
                            <el-date-picker style="width: 155px" :disabled="setReadonly" v-model="form.startDate"
                                type="date" placeholder="本学期开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="text-align: center;">
                        <el-form-item prop="endDate" label="结束日期">
                            <el-date-picker style="width: 155px" :disabled="setReadonly" v-model="form.endDate"
                                type="date" placeholder="本学期结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8" style="text-align: right;">
                        <el-form-item prop="classId" label="班级名称">
                            <el-cascader style="width:155px" :options="classes" ref="cascaderClass"
                                :disabled="setReadonly" v-model="form.classId" :show-all-levels="false" :props="props"
                                collapse-tags clearable></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="10" style="padding-left: 53px;">
                        <el-checkbox :disabled="setReadonly" v-model="form.evaluateSet"><span
                                style="font-size: 12px;">勾选此项，AI输出含有“待改进”方面的评语。</span></el-checkbox>
                    </el-col>
                    <el-col :span="14">
                        <span v-if="generateStatus === 1">
                            <el-button size="small" type="primary" @click="generateTemplate()">自动生成评语</el-button>
                        </span>
                        <span v-else-if="generateStatus === 2">
                            <el-button size="small" type="warning" @click="cancelGenerateTemplate()">取消生成</el-button>
                        </span>
                        <span v-else-if="generateStatus === 4">
                            <el-button size="small" type="primary" @click="downloadTemplate()">下载模板</el-button>
                            <el-button size="small" type="warning" @click="cancelTemplate()">删除生成评语</el-button>
                        </span>
                        <span v-if="showDraftBox" style="float: right;text-align: right;margin-right: 10px;">
                            <span style="color: red; font-size: 10px; text-align: right; margin-top: 5px;">{{draftBoxUpdateTime}}</span>
                            <el-button type="plain" @click="fillDraftBoxData">草稿箱</el-button>
                        </span>
                    </el-col>
                </el-row>

            </el-form>
            <div class="container" v-if="students.length > 0" v-loading="loading" :element-loading-text="loadingText"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255,255,0.7)">
                <div class="student-grid">
                    <div v-for="(student, index) in paginatedStudents" v-loading="loadings[index] || false"
                        element-loading-text="生成中..." element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 255,255,0.7)" :key="student.id" class="student-card">
                        <div class="student-header">{{ student.classNo }}{{ student.name }}</div>
                        <div class="comment-section">
                            <el-input type="textarea" placeholder="AI生成的评语显示在此处" :rows="5" maxlength="200"
                                show-word-limit v-model="student.newComment" style="width:420px;">
                            </el-input>
                        </div>
                        <el-tag :key="tag.name" v-for="tag in student.indexLabels" closable :type="tag.type"
                            @close="handleClose(student.indexLabels, tag)">
                            {{ tag.name }}
                        </el-tag>
                        <el-button type="warning" size="mini" style="margin-left: 3px;margin-top: 3px;"
                            @click="addIndexLabel(student)">选择指标</el-button>
                        <div class="comment-section">
                            <div class="action-wrapper">
                                <el-input type="textarea" placeholder="输入对学生主观评价的一句话" :rows="2" maxlength="100"
                                    show-word-limit v-model="student.customContent" style="width:320px;"></el-input>
                            </div>
                            <div class="button-group ">
                                <el-button type="primary" :disabled="buttonDisableds[index] || false" size="mini"
                                    @click="generateAiContent(index, student)" style="width: 98px;">
                                    {{ buttonNames[index] || `重新AI生成` }}
                                </el-button>
                                <el-button type="warning" size="mini" @click="restoreAiContent(student)"
                                    style="width: 98px;">
                                    恢复初始评语
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pagination">
                    <button v-for="page in totalPages" :key="page" class="page-btn"
                        :class="{ active: currentPage === page }" @click="currentPage = page">{{ page }}</button>
                </div>
            </div>
            <div v-else class="container" style="height: 100px; text-align: center;" v-loading="loading"
                :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255,255,0.7)">
                无数据
            </div>
        </el-dialog>

        <!--选择标签 -->
        <div v-if="indexLabelSetVisible">
            <indexLabelSet ref="indexLabelSet"></indexLabelSet>
        </div>
    </div>
</template>

<script>
import http from '../../../common/http';
import indexLabelSet from './IndexLabelSet.vue';
import io from 'socket.io-client';
import axios from 'axios';

export default {
    data() {
        return {
            visible: false,
            indexLabelSetVisible: false,
            props: { checkStrictly: true },
            form: {
                startDate: null,
                endDate: null,
                evaluateSet: false,
                deptId: "",
                classId: ""
            },
            classes: [],
            rules: {
                startDate: [
                    { required: true, message: '请选择本学期开始日期', trigger: 'blur' }
                ],
                endDate: [
                    { required: true, message: '请选择本学期结束日期', trigger: 'blur' }
                ],
                classId: [
                    { required: true, message: '请选择班级', trigger: 'blur' }
                ],
            },
            className: "",
            loading: false,
            loadingText: "",
            setReadonly: false,
            // socketio 配置信息
            socketIoClient: undefined,
            // added by lig 20250508
            closeCurrentWindow: false,
            currentPage: 1, // 当前页码
            itemsPerPage: 4, // 每页显示数量
            generateStatus: 1, // 1-正生成或者未生成，2-已生成完成
            buttonNames: [], // 按钮名称数组
            buttonDisableds: [], // 按钮是否可用数组
            loadings: [],
            students: [
                // {"name":"陈岩","endDate":"2024-12-02","sex":"女","classNo":"3","comment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","newComment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","userId":"1FEKJOOJH5E354D010AC00009F6E93AC","startDate":"2024-01-01","indexLabels":[{name:"值日生认真",type:"info"},{name:"作业打卡积极",type:"info"},{name:"眼保健操认真",type:"info"}]},
                // {"name":"陈岩","endDate":"2024-12-02","sex":"女","classNo":"3","comment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","newComment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","userId":"1FEKJOOJH5E354D010AC00009F6E93BC","startDate":"2024-01-01","indexLabels":[{name:"值日生认真",type:"info"},{name:"作业打卡积极",type:"info"},{name:"眼保健操认真",type:"info"}]},
                // {"name":"陈岩","endDate":"2024-12-02","sex":"女","classNo":"3","comment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","newComment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","userId":"1FEKJOOJH5E354D010AC00009F6E93CC","startDate":"2024-01-01","indexLabels":[{name:"值日生认真",type:"info"},{name:"作业打卡积极",type:"info"},{name:"眼保健操认真",type:"info"}]},
                // {"name":"陈岩","endDate":"2024-12-02","sex":"女","classNo":"3","comment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","newComment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","userId":"1FEKJOOJH5E354D010AC00009F6E93DC","startDate":"2024-01-01","indexLabels":[{name:"值日生认真",type:"info"},{name:"作业打卡积极",type:"info"},{name:"眼保健操认真",type:"info"}]},
                // {"name":"陈岩","endDate":"2024-12-02","sex":"女","classNo":"3","comment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","newComment":"陈岩同学，你总是以认真负责的态度对待每一项任务，无论是作为值日生，还是日常的作业打卡，都展现了你的责任心和自律性。你遵守纪律，晨读午阅全神贯注，课堂听讲认真，听写更是获得满分，这都体现了你的专注与努力。继续保持你的阅读习惯和眼保健操的认真态度，相信你会在成长的道路上越来越出色！","userId":"1FEKJOOJH5E354D010AC00009F6E93EC","startDate":"2024-01-01","indexLabels":[{name:"值日生认真",type:"info"},{name:"作业打卡积极",type:"info"},{name:"眼保健操认真",type:"info"}]},
            ],
            // 添加草稿箱，定时更新草稿箱
            showDraftBox: false,
            draftBoxUpdateTime: "", 
            draftBoxTimer: undefined,
            myCommentDraftBox: undefined
        }
    },
    created: function () {
    },
    components: {
        indexLabelSet
    },
    computed: {
        // 计算分页后的数据
        paginatedStudents() {
            const start = (this.currentPage - 1) * this.itemsPerPage
            const end = start + this.itemsPerPage
            return this.students.slice(start, end)
        },
        // 计算总页数
        totalPages() {
            return Math.ceil(this.students.length / this.itemsPerPage)
        }
    },
    methods: {
        openDialog(deptId, host, sourceType) {
            this.visible = true
            this.loading = false
            this.form.evaluateSet = false
            this.setReadonly = false
            this.generateStatus = 1

            this.closeCurrentWindow = false
            this.currentPage = 1
            this.buttonNames = []
            this.buttonDisableds = []
            this.students = []

            this.form.deptId = deptId
            this.classes = []
            this.form.classId = ""
            this.form.startDate = null
            this.form.endDate = null

            // 查询年级列表
            this.getClass()
            // 启动socket连接
            this.connect(host, sourceType)

            // 初始定时保存参数
            this.showDraftBox = false
            this.draftBoxUpdateTime = "", 
            this.myCommentDraftBox = undefined

            // 草稿箱定时更新
            this.draftBoxTimer = setInterval(() => {
                this.updateDraftBox()
            }, 10000);
        },
        // 初始化参数
        initParam(){
            let url = this.myCommentDraftBoxGetUrl
            let data = {
            };
            // console.log(JSON.stringify(data))
            // return;
            this.apiPost(url, data).then((res) => {
                console.log('初始参数', res.data)
                if (res.status == 200) {
                    this.form.startDate = res.data.startDate
                    this.form.endDate = res.data.endDate
                    if(res.data.myCommentDraftBox != undefined){
                        this.showDraftBox = true
                    }
                    // 班级不为空，默认填充
                    if(this.$util.isNotEmpty(res.data.classId)){
                        this.form.classId = this.getName(res.data.classId, this.classes)
                    }
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log('初始参数错误，原因是：', e)
            }); 
        },
        // 填充数据
        fillDraftBoxData(){
            let hintMsg = "是否加载最近一次已保存的评语记录？"
            this.$commonFn.showConfirm2(hintMsg,this.fillDraftBoxDataSuccess)
        },
        fillDraftBoxDataSuccess(){
            let url = this.myCommentDraftBoxGetUrl
            let data = {
            };
            // console.log(JSON.stringify(data))
            // return;
            this.apiPost(url, data).then((res) => {
                console.log('获取草稿箱', res.data)
                if (res.status == 200) {
                    this.form.startDate = res.data.myCommentDraftBox.startDate
                    this.form.endDate = res.data.myCommentDraftBox.endDate
                    this.form.evaluateSet = (res.data.myCommentDraftBox.evaluateSet === 1)?true:false
                    this.form.classId = this.getName(res.data.myCommentDraftBox.classId, this.classes)
                    this.students = JSON.parse(res.data.myCommentDraftBox.comments)
                    this.generateStatus = 4
                    this.setReadonly = true
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log('获取草稿箱错误，原因是：', e)
            });
        },
        updateDraftBox(){ 
            if(this.generateStatus != 4){
                return
            }

            if(this.students.length === 0){
                return
            }

            let url = this.myCommentDraftBoxUpdateUrl
            let data = {
                'classId': this.form.classId[this.form.classId.length - 1],
                'evaluateSet': this.form.evaluateSet?1:0,
                'startDate': this.form.startDate,
                'endDate': this.form.endDate,
                'comments': JSON.stringify(this.students),
            };

            // return;
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.showDraftBox = true
                    this.draftBoxUpdateTime = res.data+"评语已存档"
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log('定时更新草稿箱错误，原因是：', e)
            }); 
        },
        //查询学校所有班级
        getClass() {
            let url = this.getDeptCascaderUrl
            let data = {
            };
            this.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    this.classes = res.data.selects
                    this.initParam()
                } else {
                    this.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log(err)
            });
        },
        // 生成模板
        async generateTemplate() {
            let that = this
            that.currentPage = 1
            let isCheckPass = false
            await that.$refs['form'].validate((valid) => {
                if (valid) {
                    isCheckPass = true
                }
            })

            if (!isCheckPass) {
                return
            }

            that.generateStatus = 3
            let url = that.studentComprehensiveReportDownloadTemplateAiUrl
            let data = {
                'classId': that.form.classId[this.form.classId.length - 1],
                'socketIoSessionId': that.socketIoClient.id,
                'startDate': that.form.startDate,
                'endDate': that.form.endDate,
                'evaluateSet': that.form.evaluateSet
            }

            that.setReadonly = true
            that.loading = true
            that.loadingText = "AI评语生成中，请耐心等待..."

            // 清空
            this.students = []
            // return;
            that.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                } else {
                    that.$commonFn.showTip(res.message, 3)
                    that.generateStatus = 1
                    that.loading = false
                    that.setReadonly = false
                }
            }, (err) => {
                console.log(err)
                that.generateStatus = 1
                that.loading = false
                that.setReadonly = false
            })

        },
        // 下载
        downloadTemplate() {
            let studentsComment = {}
            let errorMsg = ""
            for (let i = 0; i < this.students.length; i++) {
                let tempStudent = this.students[i]
                studentsComment[tempStudent.userId] = tempStudent.newComment
                if (tempStudent.newComment.length > 200) {
                    if (errorMsg.length == 0) {
                        errorMsg += "异常数据反馈结果如下："
                    }
                    if (errorMsg.length > 0) {
                        errorMsg += '<br>'
                    }
                    errorMsg = errorMsg + tempStudent.classNo + tempStudent.name + '的评语超过200字，请进行调整（点击"重新AI生成"）。'
                }
            }

            // 遍历错误信息 added by ligang 20250529
            if (errorMsg != "") {
                this.$commonFn.showTip(errorMsg, 4, true)
                return
            }
            // return
            let param = new URLSearchParams();
            param.append('classId', this.form.classId[this.form.classId.length - 1])
            param.append('studentsComment', JSON.stringify(studentsComment))

            this.loading = true;
            this.loadingText = "模板生成中，请耐心等待..."
            let url = this.studentComprehensiveReportDownloadTemplateUrl;
            this.getClassNameLabel(this.form.classId[this.form.classId.length - 1], this.classes);
            axios({
                method: "post",
                url: url,
                data: param,
                responseType: "blob"
            }).then(res => {
                const link = document.createElement("a")
                let blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
                link.style.display = "none"
                link.href = URL.createObjectURL(blob)
                link.setAttribute("download", this.className + '成绩表单模板.xls')
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.loading = false
            }).catch(error => {
                console.log(error)
                this.loading = false
            });
        },
        // 获取班级名称
        getClassNameLabel(classId, classes) {
            for (let i = 0; i < classes.length; i++) {
                let obj = classes[i]
                if (obj.value == classId) {
                    this.className = obj.label
                    break;
                } else {
                    if (obj.children != null && obj.children.length > 0) {
                        this.getClassNameLabel(classId, obj.children)
                    }
                }
            }
        },
        // 连接socketIo
        connect(host, sourceType) {
            let that = this
            let url = ""
            // 源类型：1-钉钉企业内部应用，2-钉钉第三方企业应用，3-微信应用
            if (sourceType === 2 || sourceType === 3) {
                url = 'https://' + host
            } else {
                url = 'http://' + host + ':9092'
            }
            that.socketIoClient = io(url, {
                transports: ['websocket'],
                query: {
                    socketIoType: 'download'
                }
            });

            // 连接成功，监听事件
            that.socketIoClient.on("connect", (socket) => {
                console.log("socketIoClient 连接服务成功")
                let sessionId = that.socketIoClient.id
                that.subscription(sessionId)
                console.log("sessionId", sessionId)
            })

            // 关闭连接，监听事件
            that.socketIoClient.on("disconnect", (socket) => {
                if (that.closeCurrentWindow) {
                    console.log("手动关闭当前窗口，触发socketIoClient关闭连接")
                } else {
                    console.log("后台关闭链路，触发socketIoClient关闭连接")
                    that.setReadonly = false
                    this.generateStatus = 1
                    that.loading = false
                    that.$commonFn.showTip("网页连接已断开，请按下F5刷新界面重新尝试", 33)
                }
            })
        },
        // 订阅
        subscription(sessionId) {
            let that = this;
            that.socketIoClient.on(sessionId, function (data) {
                console.log('接收到后端内容', data)

                let jsonData = JSON.parse(data)
                // status：0-数据推送，1-正在生成中,2-已生成完成
                let status = jsonData.status
                if (status === 1) {
                    that.loadingText = jsonData.data
                } else if (status === 0) {
                    let student = jsonData.data
                    let indexLabels = student.indexLabels
                    if (that.$util.isNotEmpty(indexLabels)) {
                        let newIndexLabelArr = new Array()
                        let oldIndexLabelArr = indexLabels.split(",")
                        for (let i = 0; i < oldIndexLabelArr.length; i++) {
                            let indexLabel = {
                                name: oldIndexLabelArr[i],
                                type: "info"
                            }
                            newIndexLabelArr.push(indexLabel)
                        }
                        student.indexLabels = newIndexLabelArr
                    }
                    // 评语重新赋值，这样旧的评语就会保留，满足还原需求
                    student.newComment = student.comment
                    that.students.push(student)
                    that.generateStatus = 2
                } else if (status === 2) {
                    that.generateStatus = 4
                    that.loading = false
                }
            })
        },
        // 删除生成评语
        cancelTemplate() {
            let that = this
            that.students = []
            that.generateStatus = 1
            that.setReadonly = false
        },
        // 取消生成
        cancelGenerateTemplate() {
            let that = this

            that.setReadonly = true
            that.generateStatus = 3
            let url = this.studentComprehensiveReportCancelTaskUrl
            let data = {
                'socketIoSessionId': this.socketIoClient.id,
            }
            that.apiPost(url, data).then((res) => {
                if (res.status == 200) {
                    that.loading = false
                } else {
                    that.$commonFn.showTip(res.message, 3)
                }
            }, (err) => {
                console.log(err)
            })
        },
        // 指标标签删除
        handleClose(dynamicTags, tag) {
            dynamicTags.splice(dynamicTags.indexOf(tag), 1)
        },
        // 重新AI生成
        generateAiContent(index, data) {
            let that = this
            // console.log("重新AI生成",data)
            that.$set(that.buttonNames, index, `正在生成中...`)
            that.$set(that.buttonDisableds, index, true)
            that.$set(that.loadings, index, true)
            let indexLabels = new Array()
            for (let i = 0; i < data.indexLabels.length; i++) {
                let indexLabel = data.indexLabels[i]
                indexLabels.push(indexLabel.name)
            }

            let reqData = {
                'userId': data.userId,
                'customContent': data.customContent || '',
                'indexLabels': indexLabels.join(','),
            }
            let url = that.studentComprehensiveReportGenerateCommentTemplateAiUrl
            that.apiPost(url, reqData).then((res) => {
                if (res.status == 200) {
                    data.newComment = res.data
                } else {
                    data.newComment = ""
                    this.$commonFn.showTip(res.message, 3)
                }
                that.$set(this.buttonNames, index, `重新AI生成`)
                that.$set(this.buttonDisableds, index, false)
                that.$set(that.loadings, index, false)
            }, (err) => {
                console.log(err)
                data.newComment = ""
                that.$set(this.buttonNames, index, `重新AI生成`)
                that.$set(this.buttonDisableds, index, false)
                that.$set(that.loadings, index, false)
            })
        },
        // 恢复初始评语
        restoreAiContent(data) {
            data.newComment = data.comment
        },
        // 添加指标标签
        addIndexLabel(data) {
            this.indexLabelSetVisible = true
            this.$nextTick(() => {
                this.$refs['indexLabelSet'].init(data, this.form.classId[this.form.classId.length - 1])
            })
        },
        getName(setVal,data){
            // 角色、部门递归获取层级名称
            if(this.$util.isNotEmpty(data)){
                let valArr = setVal.split(",")
                let arr = new Array()
                for(let i = 0;i < valArr.length;i++){
                    let tempArr = new Array()
                    this.recursionCascader(valArr[i], data, tempArr, data)
                    arr.push(tempArr.reverse())
                }
                return arr[0]
            }
        },
        recursionCascader(val, cdata, tempArr, data){
            if(val == 0){
                return
            }
            // 递归获取值
            for(let i=0; i<cdata.length;i++){
                if(cdata[i].value == val){
                    tempArr.push(val)
                    this.recursionCascader(cdata[i].parentId, data, tempArr, data)
                }
                if(cdata[i].children && cdata[i].children.length) {
                    this.recursionCascader(val, cdata[i].children, tempArr, data)
                }
            }
        },
        dialogClose(done) {
            // 关闭socket
            if(this.socketIoClient != undefined){
                this.closeCurrentWindow = true
                this.socketIoClient.close()
                console.log("dialogClose，触发socketIoClient关闭连接")
            }

            // 关闭定时器
            if(this.draftBoxTimer != undefined){
                clearInterval(this.draftBoxTimer)
            }
            // 关闭窗口
            done()
            this.$reload
        }
    },
    destroyed() {
        // 关闭socket
        if(this.socketIoClient != undefined){
            this.closeCurrentWindow = true
            this.socketIoClient.close()
            console.log("destroyed，触发socketIoClient关闭连接")
        }

        // 关闭定时器
        if(this.draftBoxTimer != undefined){
            clearInterval(this.draftBoxTimer)
        }
        console.log("destroyed函数执行了")
    },
    mixins: [http]
}
</script>

<style scoped>
textarea {
    white-space: pre-wrap;
}

.el-tag+.el-tag {
    margin-left: 10px;
}

.student-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* 两列布局 */
    gap: 20px;
    /* 列间距 */
    margin-bottom: 20px;
}

@media (max-width: 768px) {
    .student-grid {
        grid-template-columns: 1fr;
        /* 小屏幕单列布局 */
    }
}

.container {
    max-width: 1200px;
    margin: 20px auto;
    padding: 20px;
}

.student-card {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 5px;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    /* 移除原来的margin-bottom */
    height: 100%;
    /* 保证等高效果 */
}

.student-header {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
}

.evaluation-item {
    margin: 8px 0;
    color: #666;
}

.comment-section {
    margin: 15px 0;
    padding: 10px;
    background: #f8f9fa;
    border-radius: 4px;
    color: #444;
    display: flex;
    flex-direction: row;
}

.action-wrapper {
    margin-right: 3px;
}

.button-group {
    display: flex;
    gap: 3px;
    align-items: center;
    flex-direction: column
}

.custom-btn {
    padding: 8px 16px;
    margin-right: 10px;
    border: 1px solid #409eff;
    border-radius: 4px;
    background: #ecf5ff;
    color: #409eff;
    cursor: pointer;
}

.pagination {
    margin-top: 30px;
    text-align: center;
}

.page-btn {
    display: inline-block;
    padding: 8px 12px;
    margin: 0 5px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background: #fff;
    cursor: pointer;
}

/* 分页激活状态样式（需保留） */
.page-btn.active {
    background: #409eff;
    color: white;
    border-color: #409eff;
    /* 可选添加过渡效果 */
    transition: all 0.3s ease;
}

.el-row {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/page/complexReport/DownLoadTempleat.vue